/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Upgrade_CtaInputs */

const en_interview_upgrade_cta = /** @type {(inputs: Interview_Upgrade_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Plans`)
};

const de_interview_upgrade_cta = /** @type {(inputs: Interview_Upgrade_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pläne ansehen`)
};

const fr_interview_upgrade_cta = /** @type {(inputs: Interview_Upgrade_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir les plans`)
};

const es_interview_upgrade_cta = /** @type {(inputs: Interview_Upgrade_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver planes`)
};

const it_interview_upgrade_cta = /** @type {(inputs: Interview_Upgrade_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedi piani`)
};

const nl_interview_upgrade_cta = /** @type {(inputs: Interview_Upgrade_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekijk plannen`)
};

const pl_interview_upgrade_cta = /** @type {(inputs: Interview_Upgrade_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobacz plany`)
};

const fi_interview_upgrade_cta = /** @type {(inputs: Interview_Upgrade_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Näytä suunnitelmat`)
};

const da_interview_upgrade_cta = /** @type {(inputs: Interview_Upgrade_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se planer`)
};

const sv_interview_upgrade_cta = /** @type {(inputs: Interview_Upgrade_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visa planer`)
};

/**
* | output |
* | --- |
* | "View Plans" |
*
* @param {Interview_Upgrade_CtaInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_upgrade_cta = /** @type {((inputs?: Interview_Upgrade_CtaInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Upgrade_CtaInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_upgrade_cta(inputs)
	if (locale === "fr") return fr_interview_upgrade_cta(inputs)
	if (locale === "es") return es_interview_upgrade_cta(inputs)
	if (locale === "it") return it_interview_upgrade_cta(inputs)
	if (locale === "nl") return nl_interview_upgrade_cta(inputs)
	if (locale === "pl") return pl_interview_upgrade_cta(inputs)
	if (locale === "fi") return fi_interview_upgrade_cta(inputs)
	if (locale === "da") return da_interview_upgrade_cta(inputs)
	if (locale === "sv") return sv_interview_upgrade_cta(inputs)
	return en_interview_upgrade_cta(inputs)
});